import React from 'react'

/**
 * Sibling to UI2FormSectionErrorContext. Bound fields report whether they
 * currently count as "unfilled" for the wizard's silent-replay auto-advance
 * gate. Disabled and read-only fields never count as unfilled — the user can't
 * fill them so gating replay on them would be pointless. Nested sections
 * cascade their aggregate state upward the same way errors do.
 */
export interface IUI2FormSectionFillContext {
  reportUnfilled: (id: string, isUnfilled: boolean) => void
}

const noop: IUI2FormSectionFillContext = { reportUnfilled: () => undefined }

export const UI2FormSectionFillContext = React.createContext<IUI2FormSectionFillContext>(noop)
